<!--
    @file:用户管理模块
-->
<template>
    <div id="user-management">
        <p>{{test}}</p>
    </div>
</template>

<script>
export default {
    name: 'user-management',
    created () {

    },
    data () {
        return {
            test: '这是用户管理模块'
        };
    },
    methods: {
        getMenuData () {
            /**
             * 这里是方法的说明
             *
             */
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// user-management.vue?39cb1bd0